import React from "react";
import HeroSection from "./HeroSection";
import AboutSection from "./AboutSection";

import CompanyAchievements from "./CompanyAchievements";
import WorkProcess from "./WorkProcess";
import WhyChooseUs from "./WhyChooseUs";
import ClientArea from "./ClientArea";

const About = () => {
  return (
    <>
      <HeroSection />
      <AboutSection />
      <CompanyAchievements />
      <WorkProcess />
      <WhyChooseUs />
      <ClientArea />
    </>
  );
};

export default About;
